import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import {
  isRefreshAvailable as isRefreshAvailableSelector,
  lastRefreshTime as lastRefreshTimeSelector,
} from 'containers/Project/selectors';
import { refreshProject } from 'containers/ProjectScreen/actions';
import { convertTime } from 'utils/convertTime';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

const RefreshPanel: React.FC = () => {
  const dispatch = useDispatch();
  const isRefreshAvailable = useSelector(isRefreshAvailableSelector);
  const lastRefreshTime = useSelector(lastRefreshTimeSelector);

  const handleRefresh = (): void => {
    if (!isRefreshAvailable) {
      return;
    }
    dispatch(refreshProject());
  };

  return (
    <div className={styles.RefreshPanel} data-testid="refreshPanel">
      <div
        className={styles.refreshAction}
        onClick={handleRefresh}
        data-testid="refreshPanel-action"
      >
        <Icon
          type={IconType.REFRESH}
          size="badge"
          color="primary"
          isDisabled={!isRefreshAvailable}
          dataTestId="refreshPanel-action"
        />
      </div>
      {lastRefreshTime && (
        <div className={styles.refreshTime} data-testid="refreshPanel-refreshTime">
          {intlGet('ProjectPanel', 'RefreshAt', { time: convertTime(lastRefreshTime) })}
        </div>
      )}
    </div>
  );
};

export default RefreshPanel;
